export const PDP_COACHMARK_VIEWS_LOCAL_STORAGE_KEY = 'pdp_trade_onboarding_views';
export const PDP_COACHMARK_MAX_VIEWS = 10;
export const PDP_COACHMARK_TOOLTIP_DISMISSED = 'pdp_trade_onboarding_tooltip_dimissed';
export const PDP_ONBOARDING_TRACKING_LABEL = 'pdp';
export const TRACKING_CATEGORY = 'trade onboarding';
